<template>
  <qx-card-form title="年审信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="serviceName" slot-scope="prop">
        <ChooseServicer
          :isRadio="true"
          :disabled="baseForm.disabled"
          :otherSearchData="{
            serviceType: 6,
          }"
          v-model="prop.form.serviceName"
        />
      </section>
      <div slot="certificatesInsuranceType" slot-scope="prop">
        <el-checkbox  label="行驶证" name="type" v-model="prop.form.certificatesInsuranceType" @change="drivingLicenseChange" :disabled="baseForm.disabled"/>
      </div>
    </qx-custom-form>

    <qx-custom-form
        :noSubBtn="true"
        ref="otherForm"
        :formData="otherForm"
        labelWidth="120px"
    >
      <section slot="serviceName" slot-scope="prop">
        <ChooseServicer
            :isRadio="true"
            :disabled="otherForm.disabled"
            :otherSearchData="{
            serviceType: 6,
          }"
            v-model="prop.form.serviceName"
        />
      </section>
      <div slot="certificatesInsuranceType" slot-scope="prop">
        <el-checkbox label="营运证" name="type" v-model="prop.form.certificatesInsuranceType" @change="serviceLicenseChange" :disabled="otherForm.disabled"/>
      </div>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
import { normalizeFileResponseItems } from 'api/fileResponseCompat';
import ChooseServicer from 'components/choose/servicer';
export default {
  components: {
    ChooseServicer,
  },
  data () {
    let that = this;
    return {
      oldInsuranceEndDate: '',
      baseForm: {
        disabled: false,
        form: [
          { // 行驶证
            label: '年审类型',
            value: 'certificatesInsuranceType',
            default: false,
            slot: true,
          },
          // {
          //   label: '年审类型',
          //   value: 'certificatesInsuranceType',
          //   type: 'select',
          //   default: '-1',
          //   disabled: true,
          //   options: [
          //     { label: '请选择', value: '-1' },
          //     { label: '行驶证年审', value: '1' },
          //     { label: '营运证年审', value: '2' },
          //   ],
          //   onChange: (val) => {
          //     this.selectChange(`${val}`);
          //   },
          // },
          {
            label: '年审日期',
            value: 'insuranceStartDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            hide: true,
          },
          {
            label: '有效日期',
            value: 'insuranceEndDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            hide: true,
            onChange: (val) => {
              if ((new Date(that.oldInsuranceEndDate) - new Date()) / (1000 * 60 * 60 * 24 * 30) < 6 && new Date(that.oldInsuranceEndDate) > val) {
                this.$message({
                  type: 'info',
                  message: '临近的有效日期不能修改为当前有效日期之前的时间！',
                });

                that.$refs.baseForm.setVal('insuranceEndDate', that.oldInsuranceEndDate);
              }
            },
          },
          {
            label: '年审费用',
            value: 'certificatesInsuranceFee',
            type: 'input',
            hide: true,
          },
          // {
          //   label: '登记日期',
          //   value: 'registrantionTime',
          //   type: 'input',
          //   // disabled: true,
          // hide:true,
          // },
          // {
          //   label: '注册日期',
          //   value: 'drivingLicenseDate',
          //   type: 'input',
          //   // disabled: true,
          // hide:true,
          // },
          {
            label: '服务商',
            value: 'serviceName',
            default: {},
            slot: true,
            hide: true,
          },
          {
            label: '证件图片',
            // picFileIds
            value: 'picList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            hide: true,
          },
        ],
        rules: {
          certificatesInsuranceType: [
            { required: true, message: '请选择年审类型', trigger: 'blur' },
          ],
          insuranceStartDate: [
            { required: false, message: '请选择年审日期', trigger: 'blur' },
          ],
          serviceName: [
            { required: false, message: '请选择服务商', trigger: 'blur' },
          ],
          insuranceEndDate: [
            { required: false, message: '请选择有效日期', trigger: 'blur' },
          ],

        },
      },
      otherForm: {
        disabled: false,
        form: [
          { // 营运证
            label: '年审类型',
            value: 'certificatesInsuranceType',
            default: false,
            slot: true,
          },
          // {
          //   label: '年审类型',
          //   value: 'certificatesInsuranceType',
          //   type: 'select',
          //   default: '-1',
          //   disabled: true,
          //   options: [
          //     { label: '请选择', value: '-1' },
          //     { label: '行驶证年审', value: '1' },
          //     { label: '营运证年审', value: '2' },
          //   ],
          //   onChange: (val) => {
          //     this.selectChange(`${val}`);
          //   },
          // },
          {
            label: '年审日期',
            value: 'insuranceStartDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            hide: true,
          },
          {
            label: '有效日期',
            value: 'insuranceEndDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            hide: true,
            onChange: (val) => {
              if ((new Date(that.oldInsuranceEndDate) - new Date()) / (1000 * 60 * 60 * 24 * 30) < 6 && new Date(that.oldInsuranceEndDate) > val) {
                this.$message({
                  type: 'info',
                  message: '临近有效日期不能修改为当前有效日期之前的时间！',
                });
                this.$refs.otherForm.setVal('insuranceEndDate', that.oldInsuranceEndDate);
              }
            },
          },
          {
            label: '年审费用',
            value: 'certificatesInsuranceFee',
            type: 'input',
            hide: true,
          },
          {
            label: '服务商',
            value: 'serviceName',
            default: {},
            slot: true,
            hide: true,
          },
          {
            label: '证件图片',
            // picFileIds
            value: 'picList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
            hide: true,
          },
        ],
        rules: {
          certificatesInsuranceType: [
            { required: true, message: '请选择年审类型', trigger: 'blur' },
          ],
          insuranceStartDate: [
            { required: false, message: '请选择年审日期', trigger: 'blur' },
          ],
          serviceName: [
            { required: false, message: '请选择服务商', trigger: ['change', 'blur'] },
          ],
          insuranceEndDate: [
            { required: false, message: '请选择有效日期', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setVehicleInfo (vehicleInfo) {
      // TODO
    },
    // 从车辆预警列表的处理页面进来
    async jumpFromWarn () {
      if (this.$route.query.certificatesInsuranceType === '1') {
        this.$refs.baseForm.setVal('certificatesInsuranceType', true);
        this.formChange(this.baseForm);
      } else if (this.$route.query.certificatesInsuranceType === '2') {
        this.$refs.otherForm.setVal('certificatesInsuranceType', true);
        this.formChange(this.otherForm);
      }
    },
    drivingLicenseChange (val) {
      let Field = false;
      if (val) {
        Field = true;
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['insuranceStartDate', 'insuranceEndDate', 'certificatesInsuranceFee', 'serviceName', 'picList'],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['insuranceStartDate', 'insuranceEndDate', 'certificatesInsuranceFee', 'serviceName', 'picList'],
        });
      }

      this.baseForm.rules.insuranceStartDate[0].required = Field;
      this.baseForm.rules.insuranceEndDate[0].required = Field;

    },
    serviceLicenseChange (val) {
      let Field = false;
      if (val) {
        Field = true;
        this.setFormAttrVal({
          form: this.otherForm,
          attr: 'hide',
          value: false,
          names: ['insuranceStartDate', 'insuranceEndDate', 'certificatesInsuranceFee', 'serviceName', 'picList'],
        });
      } else {
        this.setFormAttrVal({
          form: this.otherForm,
          attr: 'hide',
          value: true,
          names: ['insuranceStartDate', 'insuranceEndDate', 'certificatesInsuranceFee', 'serviceName', 'picList'],
        });
      }
      this.otherForm.rules.insuranceStartDate[0].required = Field;
      this.otherForm.rules.insuranceEndDate[0].required = Field;
    },
    // // 设备切换显示
    // selectChange (value) {
    //   this.setFormAttrVal({
    //     form: this.baseForm,
    //     attr: 'hide',
    //     value: value !== '1',
    //     names: ['registrantionTime', 'drivingLicenseDate'],
    //   });
    // },
    // 设置登记日期和注册日期
    setReviewFormVal (plateNumberInfo) {
      this.$refs.baseForm.setVal('registrantionTime', plateNumberInfo.registrantionTime || ' ');
      this.$refs.baseForm.setVal('drivingLicenseDate', plateNumberInfo.drivingLicenseDate || ' ');
    },
    // 统一处理数据格式
    async handleSubData (cache) {

      let baseformData;
      let otherformData;
      if (cache) {
        baseformData = await this.$refs.baseForm.getVal();
        otherformData = await this.$refs.otherForm.getVal();
      } else {
        baseformData = await this.$refs.baseForm.sub();
        otherformData = await this.$refs.otherForm.sub();
      }
      // 此处代码冗余原因在下方注释
      if (baseformData || cache) {
        if (baseformData.certificatesInsuranceType) {
          baseformData.certificatesInsuranceType = 1;
        }
        baseformData.insuranceStartDate = this.formatDate(baseformData.insuranceStartDate);
        baseformData.insuranceEndDate = this.formatDate(baseformData.insuranceEndDate);
        if (baseformData.picList && baseformData.picList.length) {
          for (let item of baseformData.picList) {
            item.fileId = item.id;
            item.fileUrl = item.url;
          }
        }
        if (baseformData.serviceName) {
          baseformData.serviceUserId = baseformData.serviceName.serviceUserId;
          baseformData.servicePhone = baseformData.serviceName.mobilePhone;
          baseformData.serviceName = baseformData.serviceName.serviceName;
        }
      }
      if (otherformData || cache) {
        if (otherformData.certificatesInsuranceType) {
          otherformData.certificatesInsuranceType = 2;
        }
        otherformData.insuranceStartDate = this.formatDate(otherformData.insuranceStartDate);
        otherformData.insuranceEndDate = this.formatDate(otherformData.insuranceEndDate);
        if (otherformData.picList && otherformData.picList.length) {
          for (let item of otherformData.picList) {
            item.fileId = item.id;
            item.fileUrl = item.url;
          }
        }
        if (otherformData.serviceName) {
          otherformData.serviceUserId = otherformData.serviceName.serviceUserId;
          otherformData.servicePhone = otherformData.serviceName.mobilePhone;
          otherformData.serviceName = otherformData.serviceName.serviceName;
        }
      }
      return {baseformData, otherformData};
    },
    async cacheData () {

      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = [];
      formData = await this.handleSubData();
      // 此处代码冗余原因在下方注释
      if (formData.baseformData) {
        formData.baseformData.picFileIds = '';
        if (formData.baseformData.picList && formData.baseformData.picList.length) {
          let picFileIds = [];
          for (let item of formData.baseformData.picList) {
            picFileIds.push(item.fileId);
          }
          formData.baseformData.picFileIds = picFileIds.join();
        }
        delete formData.baseformData.picList;

      }
      if (formData.otherformData) {
        formData.otherformData.picFileIds = '';
        if (formData.otherformData.picList && formData.otherformData.picList.length) {
          let picFileIds = [];
          for (let item of formData.otherformData.picList) {
            picFileIds.push(item.fileId);
          }
          formData.otherformData.picFileIds = picFileIds.join();
        }
        delete formData.otherformData.picList;
      }
      const drivingChooseState = this.$refs.baseForm.getVal('certificatesInsuranceType');
      const serviceChooseState = this.$refs.otherForm.getVal('certificatesInsuranceType');
      // 由于需求需要,此处变更为同时可新增两种年审类型数据,所以需调两次接口,判断勾选行驶证还是营运证,将表单数据传回父组件用于二次调接口用
      if (drivingChooseState && serviceChooseState) {
        this.$emit('drivingLicenseForm', formData.otherformData);
        return formData.baseformData;
      } else if (drivingChooseState && !serviceChooseState) {
        return formData.baseformData;
      } else if (!drivingChooseState && serviceChooseState) {
        return formData.otherformData;
      } else if (!drivingChooseState && !serviceChooseState) {
        this.$message({
          type: 'error',
          message: '请至少选择一个年审类型！',
        });
      }
    },
    formChange (form) {
      this.setFormAttrVal({
        form: form,
        attr: 'hide',
        value: false,
        names: ['insuranceStartDate', 'insuranceEndDate', 'certificatesInsuranceFee', 'serviceName', 'picList'],
      });

    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      this.$refs.otherForm.reset();
      // 表格点查看才会传type=detail,不知道为什么在新增修改文件里要判断type === 'detail'
      // if (this.$route.query.type === 'detail') {
      //   this.setFormAttrVal({
      //     form: this.baseForm,
      //     attr: 'disabled',
      //     value: true,
      //   });
      //   this.disabled = true;
      // } else {
      //   let names = [];
      //   let value = false;
      //   if (this.$route.query.id) {
      //     names = ['certificatesInsuranceType'];
      //     value = true;
      //   } else {
      //     names = [];
      //     value = false;
      //   }
      //   this.setFormAttrVal({
      //     form: this.baseForm,
      //     attr: 'disabled',
      //     value,
      //     names,
      //   });
      //   this.disabled = false;
      // }

      if (data.certificatesInsuranceType !== undefined) {
        if (data.certificatesInsuranceType === 1) {
          this.formChange(this.baseForm);
          this.otherForm.disabled = true; // 如果修改行驶证年审,就控制营运证年审表单不可编辑
          if (data.serviceName) {
            data.serviceName = {
              serviceName: data.serviceName,
              serviceUserId: data.serviceUserId,
              mobilePhone: data.servicePhone,
            };
          }
          let flowIds = [];
          if (data.picList && data.picList.length) {
            const picList = JSON.parse(JSON.stringify(data.picList));
            picList.forEach((item) => {
              flowIds.push(item.fileId);
            });
          }
          if (flowIds.length) {
            const imgs = await getFileUrl({
              flowIds: flowIds.join(),
              _GRID_TYPE: 'jq',
            });
            normalizeFileResponseItems(imgs).forEach((img) => {
              data.picList.forEach((pic) => {
                if (pic.fileId === img.flowId) {
                  pic.id = img.flowId;
                  pic.url = img.fullPath;
                }
              });
            });
          }
          // this.selectChange(data.certificatesInsuranceType);
          this.$refs.baseForm.setVal(data);
          this.$refs.baseForm.setVal('certificatesInsuranceType', true);
        }


        if (data.certificatesInsuranceType === 2) {
          this.formChange(this.otherForm);
          this.baseForm.disabled = true; // 如果修改营运证年审,就控制行驶证年审表单不可编辑
          if (data.serviceName) {
            data.serviceName = {
              serviceName: data.serviceName,
              serviceUserId: data.serviceUserId,
              mobilePhone: data.servicePhone,
            };
          }
          let flowIds = [];
          if (data.picList && data.picList.length) {
            const picList = JSON.parse(JSON.stringify(data.picList));
            picList.forEach((item) => {
              flowIds.push(item.fileId);
            });
          }
          if (flowIds.length) {
            const imgs = await getFileUrl({
              flowIds: flowIds.join(),
              _GRID_TYPE: 'jq',
            });
            normalizeFileResponseItems(imgs).forEach((img) => {
              data.picList.forEach((pic) => {
                if (pic.fileId === img.flowId) {
                  pic.id = img.flowId;
                  pic.url = img.fullPath;
                }
              });
            });
          }
          // this.selectChange(data.certificatesInsuranceType);
          this.$refs.otherForm.setVal(data);
          this.$refs.otherForm.setVal('certificatesInsuranceType', true);
        }
        this.oldInsuranceEndDate = data.insuranceEndDate;
      }
      this.jumpFromWarn();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
